export const BANNERS = [
  {
    img: "https://static.prod-images.emergentagent.com/jobs/c7309ffe-c5c5-47c6-bc71-4af7729b8369/images/5afaca82915e5607643aafa04e61aeabf83ade277fe41c20e3d2320c87ef6f41.jpeg",
    text: "Welcome to Shillong Lucky Ending!",
    title: "Welcome to Shillong Lucky Ending",
    details:
      "Your trusted home for the daily Shillong Lucky Ending result. A single lucky digit from 0 to 9 is declared for every 15-minute slot between 09:00 AM and 08:00 PM, and you can track all of them live right here.",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/c7309ffe-c5c5-47c6-bc71-4af7729b8369/images/f1cf3c96f492994231df5e0cd86259c92ef5339bfbe28a28fe613092424d4c7c.jpeg",
    text: "Get 100% Verified Fast Updates",
    title: "100% Verified, Lightning-Fast Updates",
    details:
      "Every Lucky Ending number is published the moment it is declared. No delays, no guesswork — the digit you see on this page is the same verified result shared from our official admin panel.",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/c7309ffe-c5c5-47c6-bc71-4af7729b8369/images/7c3110af8f03a00a41625be5207b4eb0f7ff407c86bbf9ad04415991fe45f0d9.jpeg",
    text: "Check Your Lucky Winning Number",
    title: "Check Your Lucky Winning Number",
    details:
      "Match the live ending digit with your ticket instantly. Prize structure: ₹11 wins ₹100, ₹55 wins ₹500 and ₹110 wins ₹1000. Play within your limits and always verify the official slot time.",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/c7309ffe-c5c5-47c6-bc71-4af7729b8369/images/e2956dc2bb9acdd1b52589cba5babdeb0634c62b0f9bdca01456d20c41580e52.jpeg",
    text: "Direct from Official Admin Panel",
    title: "Direct from the Official Admin Panel",
    details:
      "Results are entered and verified by our team through a secure admin panel, then saved permanently in our database. Browse the complete 7-day history on the All Results page any time.",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/c7309ffe-c5c5-47c6-bc71-4af7729b8369/images/077ba1d9889b7ff43b855eef334bbe08669ac7a29020efebf17f41a04a18ce34.jpeg",
    text: "Best of Luck for Today's Game!",
    title: "Best of Luck for Today's Game",
    details:
      "Follow the rules, respect the 18+ age limit and play responsibly. Lucky Ending is a game of chance — enjoy the thrill, never chase losses, and treat past numbers only as a reference, not a guarantee.",
  },
];

export const NUMBER_COLORS = ["#ffffff", "#ffa500", "#0be881"];
